package com.swetdot.swetgram.cache

import kotlin.Long
import kotlin.String

public data class CachedUser(
  public val id: String,
  public val username: String,
  public val displayName: String,
  public val avatarUrl: String?,
  public val bio: String?,
  public val location: String?,
  public val dateOfBirth: String?,
  public val showBirthYear: Long,
  public val isOnline: Long,
  public val lastSeenAt: Long?,
  public val isDeleted: Long,
  public val hasBlackBadge: Long,
)
